// extracted by mini-css-extract-plugin
module.exports = {"input":"SignUpInput_input__3Zk4K","label":"SignUpInput_label__DPmQN"};